import { Component, inject } from '@angular/core';
import { ApplicationService } from '../../generic/service/application.service';
import { BarcodeScannerComponent } from './barcodescanner/barcode.scanner.component';

@Component({
    selector: 'products-scanner',
    templateUrl: 'products.scanner.component.html',
    styleUrls: ['../../../assets/style/barcode.scanner.component.scss'],
    standalone: true,
    imports: [BarcodeScannerComponent],
})
export class ProductsScannerComponent {
    applicationService = inject(ApplicationService);


    openBarcodeScanner(): void {
        this.applicationService.openBarcodeScannerPopup(
            this.applicationService.closeBarcodeScannerPopup,
        );
    }
}
